<template>
   <div class="form-group">
      <label :for="`ip_${dataName}`"
             :class="['label-overlay', {active: !isNotEmpty(form.data)}]"
             @click="switchLabel($event)">{{ label }}</label>
      <input type="text"
             class="form-control"
             :name="dataName"
             :id="`ip_${dataName}`"
             @focus="switchLabel($event)"
             @blur="switchLabel($event); validateFieldData();"
             v-model.trim="form.data"
             :class="[{ 'is-invalid': isValidTextData.isInvalid }, { 'is-valid': isValidTextData.isValid }]">
      <div class="invalid-feedback">{{ invalidFeedBack }}</div>
      <div class="valid-feedback">{{ validFeedBack }}</div>
   </div>
</template>

<script>
export default {
   name: 'TextBoxComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      dataName: {
         type: String,
         default: 'box',
      },
      label: {
         type: String,
         default: '',
      },
      invalidFeedBack: {
         type: String,
         default: '',
      },
      validFeedBack: {
         type: String,
         default: '',
      },
   },
   data() {
      return {
         isValidTextData: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            data: this.value,
         },
      };
   },
   methods: {
      validateFieldData() {
         this.isValidTextData.isValid = !this.isNotEmpty(this.form.data);
         this.isValidTextData.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.data);
      },
   },
};
</script>

<style>
</style>
